// extracted by mini-css-extract-plugin
export default {"title":"styles_title__6q5ef","hint":"styles_hint__QwlQ9","addButton":"styles_addButton__QxkmG","add":"styles_add__xRZAm","wrap":"styles_wrap__f+XvJ"};